import { Button } from "@itandi/itandi-bb-ui/Button";
import { ModalBody } from "@itandi/itandi-bb-ui/ModalBody";
import { ModalFooter } from "@itandi/itandi-bb-ui/ModalFooter";
import { ModalHeader } from "@itandi/itandi-bb-ui/ModalHeader";
import { Modalv2 } from "@itandi/itandi-bb-ui/Modalv2";
import React from "react";
import { FormProvider, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import type { Deal } from "~/models/Deal";
import type { DealInspectionCandidateDateParam } from "~/models/InspectionCandidateDate";
import { buildInspectionCandidateDate } from "~/models/InspectionCandidateDate";
import { isSuccess } from "~/utils/api/api_handler";
import { update } from "~/utils/api/deals/DealInspectionCandidateDate";
import { ScheduleInputForm } from "./ScheduleInputForm";

type Props = {
	deal: Deal;
	handleClose: () => void;
	handleMutate: () => Promise<void>;
	isOpen: boolean;
};

export const ScheduleInputModal: React.FC<Props> = ({
	deal,
	isOpen,
	handleClose,
	handleMutate
}: Props) => {
	const methods = useForm<DealInspectionCandidateDateParam>({
		defaultValues: deal ? buildInspectionCandidateDate(deal) : {},
		mode: "onBlur"
	});
	const onSubmitSchedule = React.useCallback(() => {
		methods.handleSubmit(
			async (submitValue: DealInspectionCandidateDateParam) => {
				const response = await update(deal.id, submitValue);
				if (isSuccess(response)) {
					await handleMutate();
					handleClose();
					toast.success("更新しました");
					return;
				}
				toast.error("エラーが発生しました");
			}
		)();
	}, [methods, deal, handleMutate, handleClose]);
	return (
		<Modalv2 isOpen={isOpen} onClose={handleClose} size="l">
			<ModalHeader title="訪問希望日の更新" />
			<ModalBody>
				<FormProvider {...methods}>
					<ScheduleInputForm />
				</FormProvider>
			</ModalBody>
			<ModalFooter
				leftArea={
					<Button onClick={handleClose} variant="secondary">
						キャンセル
					</Button>
				}
				rightArea={
					<Button
						disabled={methods.formState.isSubmitting}
						onClick={onSubmitSchedule}
						variant="primary"
					>
						確定
					</Button>
				}
			/>
		</Modalv2>
	);
};
